import { Stack } from "@mui/material";
import { Store } from "../../api/ApiData";
import { ColorHexCodes } from "../../util/Color";
import Settings from "../../util/Settings";
import Time from "../../util/Time";
import ClassNames from "../../util/ClassNames";
import { StyledText } from "../StyledText";
import style from "./TimeTable.module.css";

export function createDaysLabelItem(page: number) {
  return Array(Settings.DateUnitCount)
    .fill(0)
    .map((_, i) => {
      const date = Time.Now().Today() + i * Time.ADay + page * Settings.DateUnitCount * Time.ADay;
      let timeString = new Time(date).DateStrings();
      let dateColor = ColorHexCodes.CharacterBlack;
      let dayColor = "7a7a7a";
      if (timeString.day === "土") {
        dateColor = "688feb";
        dayColor = "688feb";
      } else if (timeString.day === "日") {
        dateColor = ColorHexCodes.RequiredRed;
        dayColor = ColorHexCodes.RequiredRed;
      }
      return (
        <Stack key={i} className={ClassNames(style.grow, style.cell)}>
          <Stack style={{ color: `#${dateColor}` }}>
            <StyledText textStyle="NoMargin">{`${timeString.month}/${timeString.date}`}</StyledText>
          </Stack>
          <Stack style={{ color: `#${dayColor}` }}>
            <StyledText textStyle="TimeTableDay">{`${timeString.day}`}</StyledText>
          </Stack>
        </Stack>
      );
    });
}

export function getStoreBusinessHours(store: Store) {
  let businessHours = { openAt: store.open_at, closeAt: store.close_at };
  if (store.use_day_business_hour) {
    businessHours = {
      openAt: Math.min(...store.DayBusinessHours.map((businessTime) => businessTime.open_at)),
      closeAt: Math.max(...store.DayBusinessHours.map((businessTime) => businessTime.close_at)),
    };
  }
  return businessHours;
}

export function getSlotDuration(store: Store) {
  let slotDuration = store.slot_duration;
  if (slotDuration <= 0) {
    slotDuration = Settings.SlotDuration;
  }
  return slotDuration;
}